<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-20 11:22:43
 * @LastEditors: 诺
 * @LastEditTime: 2023-02-06 14:05:37
-->

<template>
  <div
    class="boxMian"
    :style="{
      backgroundColor: configInfo.backgroundColour,
    }"
  >
    <div class="page-wrapper" :style="{ backgroundImage: `url('${configInfo.backgroundImg}')` }">
      <div class="kv"><img :src="configInfo.mainKvImg" /></div>
      <BaseBottom :configInfo="configInfo" />
      <ActBaseBtnHome :bColor="configInfo.buttonBackgroundColour" :textColor="configInfo.buttonTextColour"></ActBaseBtnHome>

      <div :class="['model',`theme${$configInfo.uiExt.uiExtTemplate}`]" :style="{ backgroundColor: `${configInfo.mainColour}80` }">
        <div
          class="modelTitle"
          :style="{
            backgroundColor: configInfo.mainColour,
            color: configInfo.buttonTextColour,
          }"
        >
          · 规则说明 ·
        </div>

        <div class="modelBg">
          <div class="rule" v-html="configInfo.actRule"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue/dist/vue.js";
// import Grid from "./components/grid";
// import Pointer from "./components/pointer";
// import ButtonList from "./components/buttonList";
// import { getUserInfo2 } from "@/http/rushi-wx";
import util from "@/utils/common";

// const statusTipMap = {
//   0: "该活动无效",
//   1: "该活动待发布",
//   2: "该活动未上线",
//   4: "该活动已下线",
//   5: "该活动已下线",
// };

export default {
  components: {},
  props: {},

  data() {
    return {
      configInfo: {}, //配置信息
    };
  },

  mounted() {
    this.initAct();
    if (this.$configInfo.shareSwitch!= 1) {
      this.$wx.hideOptionMenu();
    }
  },
  methods: {
    // 页面配置
    async initAct() {
      this.$showLoading();
      let url = this.$apizt.action.getConfig;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.configInfo = JSON.parse(data.uiExt);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  height: 100vh;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 40px;

    .kv {
      width: 343px;
      margin: 40px auto 0;
      img {
        max-width: 100%;
        height: auto;
      }
    }

    .model {
      width: 351px;
      margin: 36px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 12px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      background-color: rgba(255, 255, 255, 0.1);
      padding:10px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      &.theme5{
        margin-top:-264px;
      }


      .modelTitle {
        position: absolute;
        margin-top: -10px;
        color: white;
        padding: 0 20px;
        line-height: 40px;
        height: 40px;
        text-align: center;
        border-radius: 6px;
        display: inline-block;
        font-weight: bold;
        z-index: 1;
        font-size: 20px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        border-radius: 0px 0px 12px 12px;
      }

      .modelBg {
        width: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 6px;
        padding: 40px 20px 20px;

        .rule {
          word-break: break-all;
          overflow-y: auto;
          font-size: 14px;
          line-height: 160%;
        }
      }
    }
  }
}
</style>
